/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseModifiedByField
 */
export interface DatabaseModifiedByField extends DatabaseField {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseModifiedByField
     */
    userFields?: Array<string>;
}

/**
 * Check if a given object implements the DatabaseModifiedByField interface.
 */
export function instanceOfDatabaseModifiedByField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseModifiedByFieldFromJSON(json: any): DatabaseModifiedByField {
    return DatabaseModifiedByFieldFromJSONTyped(json, false);
}

export function DatabaseModifiedByFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseModifiedByField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'userFields': !exists(json, 'userFields') ? undefined : json['userFields'],
    };
}

export function DatabaseModifiedByFieldToJSON(value?: DatabaseModifiedByField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'userFields': value.userFields,
    };
}

